import { Link } from "react-router";
import { LuPlus } from "react-icons/lu";
import TopBar from "../common/TopBar";
import MainContent from "./children/MainContent";
import { useNetworks } from "./useNetworks";
import { NETWORK_MANAGER_ROUTE_PATHS } from "../common/constants";
import "./Networks.scss";

/**
 * Networks list screen — presentational shell delegating state to {@link useNetworks}.
 *
 * @returns {import('react').JSX.Element}
 */
const Networks = () => {
    const {
        searchCriteria,
        setSearchCriteria,
        visibleNetworkConfigs,
        appliedSearchCriteria,
        sortedField,
        isSortDescending,
        handleSort,
        isLoading,
        isError,
        loadErrorMessage,
    } = useNetworks();

    const networkConfigsForTable =
        isLoading || isError ? [] : visibleNetworkConfigs;

    return (
        <div className="networks-page">
            <TopBar
                variant="list"
                className="plan-manager-top-bar--space-between"
            >
                <TopBar.Search
                    value={searchCriteria}
                    onChange={setSearchCriteria}
                    placeholder="Search client"
                    ariaLabel="Search client"
                />
                <TopBar.Actions>
                    <Link
                        to={NETWORK_MANAGER_ROUTE_PATHS.NETWORKS_CONFIG}
                        className="plan-manager-top-bar__create-link"
                    >
                        Create new client
                        <LuPlus aria-hidden size={18} />
                    </Link>
                </TopBar.Actions>
            </TopBar>

            {isLoading && (
                <p className="networks-page__loading" role="status">
                    Loading networks...
                </p>
            )}

            {isError && (
                <p className="networks-page__error" role="alert">
                    {loadErrorMessage}
                </p>
            )}

            <MainContent
                networkConfigs={networkConfigsForTable}
                searchCriteria={appliedSearchCriteria}
                sortedField={sortedField}
                isSortDescending={isSortDescending}
                onSort={handleSort}
            />
        </div>
    );
};

export default Networks;
